import { IActivityLogs, ICageActivityLog, ICreateCustomCageLog } from 'src/generated-types/activity-logs'
import { activityLogQueryKey } from 'src/query-keys'
import { queryClient } from '../query-client'
import { useDelete, useGet, usePost } from './reactQuery'

const activityLogBaseURL = () => 'activity-logs'

export const activityLogEndpoints = {
  getCageActivityLogs() {
    return `${activityLogBaseURL()}/get-all-cage-activity-logs`
  },
  getCageMaintenanceLogs() {
    return `${activityLogBaseURL()}/get-cage-maintenance-logs`
  },
  getMainComponentActivityLogs() {
    return `${activityLogBaseURL()}/get-main-component-activity-logs`
  },
  createCustomCageLog() {
    return `${activityLogBaseURL()}/create-cage-custom-log`
  },
  deleteCustomActivityLog() {
    return `${activityLogBaseURL()}/delete-custom-activity-log`
  },
}

export const invalidationActivityLogCache = {
  getCageActivityLogs(queryParams?: object) {
    queryClient.invalidateQueries(activityLogQueryKey.GET_ACTIVITY_LOGS(queryParams))
  },
  getCageMaintenanceLogs(queryParams?: object) {
    queryClient.invalidateQueries(activityLogQueryKey.GET_MAINTENANCE_LOGS(queryParams))
  },
  getMainComponentActivityLogs(queryParams?: object) {
    queryClient.invalidateQueries(activityLogQueryKey.GET_ACTIVITY_LOGS(queryParams))
  },
}

export const useGetCageActivityLogs = (queryParams?: { positionId: EntityId; page: number; pageSize: number }) =>
  useGet<Array<ICageActivityLog>>(
    activityLogEndpoints.getCageActivityLogs(),
    {
      ...queryParams,
    },
    {
      queryKey: activityLogQueryKey.GET_ACTIVITY_LOGS({
        positionId: queryParams?.positionId,
        page: queryParams?.page,
        pageSize: queryParams?.pageSize,
      }),
    },
  )

export const useGetCageMaintenanceLogs = (queryParams?: { positionId: EntityId; page: number; pageSize: number }) =>
  useGet<Array<ICageActivityLog>>(
    activityLogEndpoints.getCageMaintenanceLogs(),
    {
      ...queryParams,
    },
    {
      queryKey: activityLogQueryKey.GET_MAINTENANCE_LOGS({
        positionId: queryParams?.positionId,
        page: queryParams?.page,
        pageSize: queryParams?.pageSize,
      }),
    },
  )

export const useGetMainComponentActivityLogs = (queryParams?: {
  mainComponentId: EntityId
  page: number
  pageSize: number
}) =>
  useGet<Array<IActivityLogs>>(
    activityLogEndpoints.getMainComponentActivityLogs(),
    {
      ...queryParams,
    },
    {
      queryKey: activityLogQueryKey.GET_ACTIVITY_LOGS({
        mainComponentId: queryParams?.mainComponentId,
        page: queryParams?.page,
        pageSize: queryParams?.pageSize,
      }),
    },
  )

export const useAddCustomCageLog = () =>
  usePost<ICageActivityLog, ICreateCustomCageLog>(activityLogEndpoints.createCustomCageLog())

export const useDeleteActivityLog = () => useDelete<IActivityLogs>(activityLogEndpoints.deleteCustomActivityLog())
